import React from 'react';

const inputField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div className={`form-group ${touched && error ? 'has-error' : ''}`}>
    <label>{label}</label>
    <input {...input} type="text" className="form-control" />
    {(touched && error) && <label id={`${input.name}-error`} className="error" htmlFor={input.name}>{error}</label>}
  </div>
);

export default inputField;



// WEBPACK FOOTER //
// ./src/components/RequestForm/InputField.js